import { Form, Formik } from 'formik'
import React from 'react'
import * as yup from 'yup'

import FormGroup from '@/components/form/FormGroup'
import RichTextInput from '@/components/form/RichTextInput'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { getTextFromHtmlString } from '@/lib/helpers/helperFunctions'

interface Props {
  text?: string
  onSave: (text: string) => void
  onHide: () => void
}

interface FormValues {
  text: string
}

const FormFields: Record<keyof FormValues, keyof FormValues> = {
  text: 'text',
}

const EditCommissionJustificationModal: React.FC<Props> = ({
  text,
  onSave,
  onHide,
}) => {
  const initialValues: FormValues = {
    text: text || '',
  }

  const validationSchema = yup.object().shape({
    [FormFields.text]: yup
      .string()
      .test('required', 'Please enter something.', (value) => {
        const text = getTextFromHtmlString(value || '')

        return text.trim().length > 0
      }),
  })

  return (
    <Dialog open onHide={onHide}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit text</DialogTitle>
        </DialogHeader>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => onSave(values.text)}
        >
          {({ dirty }) => (
            <Form>
              <DialogBody>
                <FormGroup>
                  <RichTextInput
                    autoFocus
                    name={FormFields.text}
                    placeholder="Enter text..."
                  />
                </FormGroup>
              </DialogBody>

              <DialogFooter>
                <Button variant="outline-secondary" onClick={onHide}>
                  Cancel
                </Button>

                <Button type="submit" disabled={!dirty}>
                  Save changes
                </Button>
              </DialogFooter>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}

export default EditCommissionJustificationModal
